export const RESCAN_TOOLTIP =
  'Search all networks and connect to the strongest signal';
export const REFRESH_TOOLTIP =
  'Restart your connection to fix connectivity issues';
export const RECONNECT_DESCRIPTION =
  'Your device is optimizing the network. You will be briefly disconnected.';
export const RECONNECT_TIMEOUT_DESCRIPTION =
  'It appears to have taken more time than expected. Once you notice the LED for network appear on the device, please refresh this page again to see updated status.';
